<script>
export default {
  page: {
    title: 'Isabel Symptom Check',
    meta: [
      { name: 'description', content: 'The Isabel Symptom Checker page.' },
    ],
  },
  data() {
    return {
      isableSymptomCheckerURL:
        'https://symptomchecker.isabelhealthcare.com/index.jsp?passcode=CJK0Xj6NCaVeDIp6tpK3op7Q4Yl5Kv2S',
    }
  },
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        :class="[
          $style.heightClss,
          $vuetify.breakpoint.smAndDown ? 'pt-0 pb-2' : '',
          $vuetify.breakpoint.xs ? 'pt-6 pb-2' : '',
        ]"
      >
        <iframe
          v-if="isableSymptomCheckerURL"
          id="sc-iframe"
          :src="isableSymptomCheckerURL"
          frameborder="0"
          :class="[
            $style.noBorder,
            $vuetify.breakpoint.smAndDown ? 'mt-1' : ' ',
          ]"
          title="Isabel Symptom Checker"
        ></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.noBorder {
  position: relative;
  width: 100% !important;
  min-height: 810px;
}
@media screen and (max-width: 799px) {
  .heightClss {
    height: 90vh;
  }
  .noBorder {
    min-height: 88vh;
  }
}
@media screen and (max-width: 430px) {
  .heightClss {
    height: 80vh;
  }
  .noBorder {
    min-height: 78vh;
  }
}
@media screen and (max-width: 360px) {
  .heightClss {
    height: 80vh;
  }
  .noBorder {
    min-height: 78vh;
  }
}
</style>
